
import { computed, defineComponent, PropType, toRefs } from 'vue'
import { ISlice } from '@invivodf/common/src/contexts/discount/domain/Discount'
import { DiscountMeasureUnits, DiscountUnits, DiscountTypes } from '@invivodf/module-discount-sdk'
import { formattedMeasureUnits } from '@invivodf/common/src/contexts/discount/domain/formattedMeasureUnits'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'

export default defineComponent({
  name: 'CDiscountScaleDetail',
  props: {
    scale: {
      type: Array as PropType<ISlice[]>,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
    measureUnit: {
      type: String as PropType<DiscountMeasureUnits | null>,
      required: true,
    },
    discountType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const i18n = useI18nForVue2()

    const { discountType, measureUnit, unit } = toRefs(props)

    return {
      formatMeasureUnit(value = 0) {
        if (discountType.value === DiscountTypes.OnRevenue) return DiscountUnits.Euro
        if (value <= 1) return i18n.t(formattedMeasureUnits[measureUnit.value!].single).toString()
        return i18n.t(formattedMeasureUnits[measureUnit.value!].plural).toString()
      },
      discountUnit: computed(() =>
        unit.value === '€' && measureUnit.value
          ? `${unit.value}/${i18n.t(formattedMeasureUnits[measureUnit.value].single).toString()}`
          : unit.value,
      ),
    }
  },
})
